import { render } from "./ImageElementOperate.vue?vue&type=template&id=5b0628aa&scoped=true&ts=true"
import script from "./ImageElementOperate.vue?vue&type=script&lang=ts"
export * from "./ImageElementOperate.vue?vue&type=script&lang=ts"

import "./ImageElementOperate.vue?vue&type=style&index=0&id=5b0628aa&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0628aa"]])

export default __exports__